import Vue from "vue";
import Router from "vue-router";
import MainLayoutContainer from "@/containers/layout/MainLayoutContainer";
import HomeRoutes from "./home";
import ServicesRoutes from "./services";
import ContactUsRoutes from "./contactUs";

Vue.use(Router);

const routes = [
  {
    path: "",
    component: MainLayoutContainer,
    children: [...HomeRoutes, ...ServicesRoutes, ...ContactUsRoutes]
  },
  { path: "*", redirect: "" }
];

const router = new Router({
  mode: "history",
  routes
});

export default router;
